<template>
  <div class='MobileHomeView-container'>
    <div v-if="appName" class="appName">
      <div>{{ appName }}</div>
      <img src="http://down.qwdata.vip/guanwang/mobile/iphone.png" v-if="ios" class="btn" @click="handleDowloadApp">
      <img src="http://down.qwdata.vip/guanwang/mobile/anzhuo.png" v-else class="btn" @click="handleDowloadApp">
      <div v-if="phoneImage" class="phone" :style="{backgroundImage: 'url('+phoneImage+')'}"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileHomeView',
  data () {
    return {
      ios: false,
      appName: '驾校考试通',
      phoneImage: 'ui3.jpg',
      phone: '1logo.png',
      androidPackageName: 'com.qw.jiakao',
      iosId: 'id1662432981'
    }
  },
  created () {
    this.ios = navigator.appVersion.toLowerCase().indexOf('iphone') > -1
    if (location.host.indexOf('jiaxiaokaoshitong.com') > -1) {
      location.href = 'https://wxaurl.cn/xrIjBMWaYSs'
      this.beian = '京ICP备19027719号-4'
      this.appName = '驾校考试通'
      this.host = 'jiaxiaokaoshitong.com'
      this.phoneImage = 'ui3.jpg'
      this.logo = '1logo.png'
    } else if (location.host.indexOf('xiaokoudai.cn') > -1) {
      this.beian = '津ICP备2024012853号-1'
      this.host = 'xiaokoudai.cn'
      this.appName = '驾考全能王'
      this.phoneImage = '1.png'
      this.logo = '1logo.png'
    } else if (location.host.indexOf('jiakaoxintiku.com') > -1) {
      this.beian = '京ICP备19027719号-20'
      this.host = 'jiakaoxintiku.com'
      this.appName = '驾考一点全科通'
      this.phoneImage = '2.jpg'
      this.logo = '2log.png'
    } else if (location.host.indexOf('h4321.com') > -1) {
      this.beian = '京ICP备2024063902号-1'
      this.host = 'h4321.com'
      this.appName = '驾考速通'
      this.phoneImage = '1.png'
      this.logo = 'logo3.png'
    } else if (location.host.indexOf('lanmaojk.top') > -1) {
      this.beian = '鄂ICP备2023005790号-1'
      this.host = 'lanmaojk.top'
      this.appName = '蓝猫驾考'
      this.phoneImage = '1.png'
      this.logo = 'logo3.png'
    }
  },
  methods: {
    // 判断当前是安卓设备还是ios设备
    getDeviceType () {
      const userAgent = navigator.userAgent
      if (/Android/i.test(userAgent)) {
        return 'Android'
      } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
        return 'iOS'
      } else {
        return 'Other'
      }
    },
    // 是否为微信环境
    isWeChatEnvironment () {
      const userAgent = navigator.userAgent
      return /MicroMessenger/i.test(userAgent)
    },

    // 页面逻辑
    handleDowloadApp () {
      const type = this.getDeviceType()
      if (type === 'iOS') {
        window.location.href = 'itms-appss://apps.apple.com/cn/app/' + this.iosId
      } else if (type === 'Android') {
        this.detectDeviceBrand()
      } else {
        console.log('其他')
      }
    },
    detectDeviceBrand  () {
      /* 包名 xxxxxxx */
      if (this.isWeChatEnvironment()) {
        window.location.replace('https://a.app.qq.com/o/simple.jsp?pkgname=' + this.androidPackageName)
        return
      }
      window.location.replace('market://details?id=' + this.androidPackageName)
    }
  }
}
</script>

<style lang='less'>
html, body, #app, .HomeScreen-container, .MobileHomeView-container {
  height: 100%;
}

.MobileHomeView-container {
  //background-image: url("http://down.qwdata.vip/guanwang/mobile/shoujibanben.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-color: #0560f4;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-position: top;
  position: relative;

  .appName {
    padding-top: 90px;
    font-size: 60px;
    left: 0;
    right: 0;
    top: 0;
    color: #fff;
    position: absolute;
    text-align: center;
    font-weight: bold;
  }

  .phone {
    position: fixed;
    overflow: hidden;
    left: 50px;
    right: 50px;
    top: 265px;
    bottom: 0;
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    background-size: 100% auto;
  }

  .btn {
    width: 142px;
    margin-top: 30px;

    &.single {
      margin-top: 180px;
    }
  }
}
</style>
